export const TIRE_DELIMITER = '||';

export const OUTSIDE_TEMPERATURE_THRESHOLDS = {LOW: 19, HIGH: 22, UNKNOWN: 999} as const;

export enum PressureUnit {
  PSI,
  KPA,
  BAR,
}

export enum TireStatus {
  NORMAL,
  CAUTION,
  WARNING,
}

export enum TirePressureAccuracy {
  LOW,
  ACCURATE,
  HIGH,
  UNKNOWN,
  ERROR,
}

export enum TirePressureStatus {
  LOWER = 'lower',
  HIGER = 'higher',
  INBOUND = 'inbound',
  WARNING = 'warning',
}

export enum TirePressureWairningLamp {
  OFF,
  ON,
}

/**
 * 적정 타이어 공기압
 * 0.8 * pressure < tire < pressure + 5
 */
export const TIRE_PRESSURE_THRESHOLD = {
  LOW_PRESSURE_MULTIPLIER: 0.8,
  HIGH_PRESSURE_ADDITION: 5,
};
